import { useRequest } from 'ahooks';
import { useState } from 'react';
import {
  getMySupportListService,
  getMySupportOperationService,
} from './services';

export default function MySupportManagementsModel() {
  const [openAddSupportModal, setOpenAddSupportModal] = useState(false);
  const [currentHandleType, setCurrentHandleType] = useState<string>('ADD'); // Operation操作项默认为ADD
  const [selectedRow, setSelectedRow] = useState<any>({}); // 选中的行数据
  const [downloading, setDownloading] = useState<boolean>(false); // 下载文件状态loading
  const [dmsFiles, setDmsFiles] = useState<any>(); // 存储上传的图标内容

  const {
    data: mySupportList,
    loading: queryMySupportListLoading,
    runAsync: queryMySupportList,
    refresh,
  } = useRequest(getMySupportListService, {
    manual: true,
  });

  const { loading, runAsync: supportOperation } = useRequest(
    getMySupportOperationService,
    {
      manual: true,
    },
  );

  return {
    loading,
    downloading,
    selectedRow,
    queryMySupportListLoading,
    openAddSupportModal,
    currentHandleType,
    mySupportList,
    dmsFiles,
    supportOperation,
    queryMySupportList,
    setCurrentHandleType,
    setOpenAddSupportModal,
    setSelectedRow,
    setDownloading,
    setDmsFiles,
    refresh,
  };
}
